module.exports = __webpack_public_path__ + "img/pr-6.f64723fe.png";